// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; 2024 Consent Management App. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
